<template>
  <div class="result-wrapper">
    <header class="ant-layout-header">
      <div class="left">
        BOBO公式 <span class="header-label"> {{ modeText }}</span>
      </div>
    </header>

    <div class="user-info">
      <div>
        <div class="label">患者姓名(Name):</div>
        <a-input v-model:value="params.name" placeholder="患者姓名(Name)" />
      </div>
      <div>
        <div class="label">患者年龄(Age):</div>
        <a-input v-model:value="params.age" placeholder="患者年龄(Age)" />
      </div>
      <div>
        <div class="label">患者ID:</div>
        <a-input v-model:value="params.id" placeholder="患者ID" />
      </div>
      <div>
        <div class="label">医生(Surgeon):</div>
        <a-input v-model:value="params.Surgeon" placeholder="医生(Surgeon)" />
      </div>
    </div>

    <a-layout-content style="padding: 0 20px">
      <div class="data-wrapper">
        <template v-if="rightTableData.length > 0">
          <a-divider></a-divider>
          <a-space>
            <div class="eye">右眼 <span>(OD)</span></div>

            <div class="params-wrapper">
              <div>
                眼轴长： <span>{{ params.odal }}</span>
              </div>
              <div>
                K值(K1)：<span>{{ params.odk1 }}</span>
              </div>
              <div>
                K值(K2)：<span>{{ params.odk2 }}</span>
              </div>
              <div>
                前房深度(ACD)：<span>{{ params.odacd }}</span>
              </div>
              <div>
                目标屈光度(Target)：<span>{{ params.odtarget }}</span>
              </div>
              <div>
                A常数(A constant)：<span>{{ params.odaConstant }}</span>
              </div>
              <div>
                预算的IOL度数：<span>{{ params.odIOL }}</span>
              </div>
            </div>
          </a-space>

          <a-table :columns="tableColums" :data-source="rightTableData" :pagination="false" />
        </template>
        <template v-if="leftTableData.length > 0">
          <a-divider></a-divider>
          <a-space>
            <div class="eye">左眼 <span>(OS)</span></div>
            <div class="params-wrapper">
              <div>
                眼轴长：<span>{{ params.osal }}</span>
              </div>
              <div>
                K值(K1)：<span>{{ params.osk1 }}</span>
              </div>
              <div>
                K值(K2)：<span>{{ params.osk2 }}</span>
              </div>
              <div>
                前房深度(ACD)：<span>{{ params.osacd }}</span>
              </div>
              <div>
                目标屈光度(Target)：<span>{{ params.ostarget }}</span>
              </div>
              <div>
                A常数(A constant)：<span>{{ params.osaConstant }}</span>
              </div>
              <div>
                预算的IOL度数：<span>{{ params.osIOL }}</span>
              </div>
            </div>
          </a-space>
          <a-table :columns="tableColums" :data-source="leftTableData" :pagination="false" />
        </template>
      </div>
    </a-layout-content>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();

const params = reactive({
  name: "",
  age: "",
  id: "",
  Surgeon: "",
  refractiveIndex: "1.3375",
  odal: "",
  odwtw: "",
  odcct: "",
  odlt: "",
  odaConstant: "",
  odtarget: "0",
  odacd: "",
  odk2: "",
  odk1: "",
  odIOL: "",
  osal: "",
  oswtw: "",
  oscct: "",
  oslt: "",
  osaConstant: "",
  ostarget: "0",
  osacd: "",
  osk2: "",
  osk1: "",
  osIOL: "",
});

const rightTableData = reactive([]);

const leftTableData = reactive([]);

const handleEdit = () => {
  router.back();
};

const tableColums = [
  {
    title: "IOL度数",
    dataIndex: "iol",
    align: "center",
  },
  {
    title: "残留屈光度(SE,D)",
    dataIndex: "se",
    align: "center",
  },
];

const modeText = computed(() => {
  if (mode.value === 1) {
    return "(此公式不适用于角膜屈光手术后的IOL计算)";
  }
  if (mode.value === 2) {
    return "不适用于RK术后 Don't for Post RK Surgery";
  }
});

const mode = ref(1);


const init = () => {
  rightTableData.length = 0;
  leftTableData.length = 0;
  const val = route;
  const data = JSON.parse(val.query.params);
  Object.keys(params).forEach((e) => {
    params[e] = data[e] || "";
  });
  mode.value = data.mode || 1;
  leftTableData.push(...JSON.parse(val.query.leftTableData));
  rightTableData.push(...JSON.parse(val.query.rightTableData));
};

init();

onMounted(() => {
  window.print();
  window.onafterprint = () => {
    window.parent.postMessage("closeIframe", "*");
  };
});
</script>

<style lang="less" scoped>
@media print {
  @page {
    margin: 0;
  }
  body {
    margin: 0;
    /deep/ .ant-table-thead > tr > th {
      background: #fafafa !important;
    }
  }
}

/deep/ .ant-divider {
  border-top: 1px solid rgba(0, 0, 0, 1);
  margin-top: 40px;
}

.result-wrapper {
  padding: 67px 92px;
  width: 1200px;
  .ant-layout-header {
    font-size: 38px;
    color: #37aea5;
    padding: 0;
    background: #fff;
    font-weight: bold;
    .header-label {
      font-weight: 400;
      font-size: 19px;
      color: #ff0000;
    }
  }
  .user-info {
    margin-top: 40px;
    background: #fafafa;
    padding: 40px 40px 8px;
    font-weight: 400;
    font-size: 19px;
    color: #4c4c4c;
    line-height: 27px;
    display: flex;
    flex-wrap: wrap;
    div {
      width: 50%;
      display: flex;
      flex-wrap: nowrap;
      margin-bottom: 32px;
      align-items: center;
      .label {
        width: 165px;
        margin-bottom: 0;
      }
      /deep/ input {
        font-size: 19px;
        text-align: center;
        width: 188px;
        border: none;
        background: none;
        border-bottom: 1px solid #e9e9e9;
      }
    }
  }

  .data-wrapper {
    .eye {
      font-weight: 700;
      font-size: 54px;
      color: #333333;
      letter-spacing: 2px;
      width: 112px;
      line-height: 34px;
      text-align: center;
      span {
        font-weight: 400;
        font-size: 22px;
        color: #4c4c4c;
      }
    }
    /deep/ .ant-table-thead > tr > th {
      background: #fafafa !important;
    }
    /deep/ .ant-table-thead > tr > th {
      padding: 8px;
    }
    /deep/.ant-table-tbody > tr > td {
      padding: 8px;
    }
    /deep/ tbody :nth-child(5) > td {
      color: #35b7ad;
    }
    .params-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-bottom: 20px;
      padding-left: 60px;
      div {
        font-weight: 400;
        font-size: 19px;
        color: #4c4c4c;
        width: 255px;
        line-height: 40px;
        span {
          color: #37aea5;
        }
      }
    }
  }
}
</style>
